var map = {
	"./ball.png": 4616,
	"./boots.png": 6846,
	"./medal.png": 4906,
	"./red-card.png": 870,
	"./shirt.png": 5291,
	"./strategy.png": 6423,
	"./time.png": 3711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7835;